module.exports = __webpack_public_path__ + "static/gallery-14@2x-56c29a35a45708122f56ca2d17273163.jpg";